import React, { useMemo } from "react"
import ReactDOM from "react-dom"

import Stepper from "../Stepper/Stepper"
import useRaiseTicketForm from "./useRaiseTicketForm"
import { currentComponent } from "./config/mapping"

import close_icon from "../../assets/images/close_icon.svg"
import "./RaiseTicketFormBeta.scss"

export type FormPageProps = {
    handleNextStep: () => void
    handleCloseForm: () => void
    module?: EFormModule
    isLastStep?: boolean
    redirectPage?: boolean
}

export enum EFormModule {
    PROJECTS = "projects",
    LOGISTICS = "logistics",
    SURVEYS = "surveys",
    DEMOLITION = "demolition",
    EV_APPLICATION = "ev_application",
}

type Props = {
    isOpen: boolean
    onClose: () => void
    module?: EFormModule
    redirectPage?: boolean
}

const RaiseTicketForm = ({ isOpen, onClose, module = EFormModule.PROJECTS, redirectPage }: Props) => {
    const { states, functions } = useRaiseTicketForm({ module, onClose, isOpen })
    const allowedStepsArray = useMemo(() => Array.from(states.allowedSteps), [states.allowedSteps])
    if (!isOpen) return null

    return ReactDOM.createPortal(
        <div className="raise-ticket-form-modal__overlay">
            <div className="raise-ticket-form-modal__content" onClick={e => e.stopPropagation()}>
                <div className="raise-ticket-form">
                    <header className="raise-ticket-form__header">
                        <img
                            src={close_icon}
                            alt="close"
                            className="raise-ticket-form__header-close"
                            onClick={functions.handleClose}
                            height={12}
                            width={12}
                        />
                        {/* Title */}
                        <div>
                            <div className="raise-ticket-form__header-heading">
                                {module === EFormModule.SURVEYS ? "New Survey" : "New Project"}
                            </div>
                            <div className="raise-ticket-form__header-subheading">Fill out the following details</div>
                        </div>
                        {/* Stepper */}
                        <Stepper
                            activeFromParent={states.step}
                            allowed={allowedStepsArray}
                            steps={states.stepsArray}
                            onChange={(value: number) => {
                                functions.handleStepChange(value)
                            }}
                        />
                    </header>
                    <main className="raise-ticket-form__main">
                        {React.createElement(currentComponent(states.currentPage), {
                            handleNextStep: functions.handleNextStep,
                            handleCloseForm: functions.handleClose,
                            module: module,
                            redirectPage: redirectPage,
                            isLastStep: states.step === states.stepsArray.length,
                        })}
                    </main>
                </div>
            </div>
        </div>,
        document.body
    )
}

export default RaiseTicketForm
